<template>
	<div class="pa-6 ao-form-footer">
		<template v-if="!hideSaveBtn">
			<v-menu
				v-if="saveAndContinueBtn"
				v-model="menu"
				location="bottom"
				:close-on-content-click="true"
			>
				<template v-slot:activator="{ props }">
					<ao-btn
						color="primary"
						class="mr-6"
						:loading="loading"
						@click="onSubmit"
					>
						{{ $t('Save') }}
						<ao-icon
							v-bind="props"
							class="ml-2 ao-h1"
							iconName="angleDown"
						/>
					</ao-btn>
				</template>
				<v-card
					width="203"
					class="pa-2 mt-1"
				>
					<ao-btn
						color="primary"
						variant="flat"
						class="w-100 mb-2"
						@click="onSubmit"
					>
						{{ $t('Save') }}
					</ao-btn>
					<ao-btn
						class="w-100"
						color="secondary"
						variant="flat"
						@click="onSubmit(true)"
					>
						{{ $t('Save and continue') }}
					</ao-btn>
				</v-card>
			</v-menu>
			<v-menu
				v-else-if="saveAddCloseAndNewBtn"
				v-model="menuSaveAddCloseAndNewBtn"
				:close-on-content-click="true"
			>
				<template v-slot:activator="{ props }">
					<ao-btn
						color="primary"
						class="mr-6"
						:loading="loading"
						@click="onSubmit('saveAndContinue')"
					>
						{{ $t('Save and add') }}
						<ao-icon
							v-bind="props"
							class="ml-2 ao-h1"
							iconName="angleDown"
						/>
					</ao-btn>
				</template>
				<v-card
					width="203"
					class="pa-2 mt-1"
				>
					<ao-btn
						class="w-100 mb-2"
						color="primary"
						variant="flat"
						@click="onSubmit('saveAndContinue')"
					>
						{{ $t('Save and add') }}
					</ao-btn>
					<ao-btn
						color="secondary"
						variant="flat"
						class="w-100 mb-2"
						@click="onSubmit('saveAndClose')"
					>
						{{ $t('Save and close') }}
					</ao-btn>
					<ao-btn
						class="w-100"
						color="secondary"
						variant="flat"
						@click="onSubmit('createNew')"
					>
						{{ $t('Create new') }}
					</ao-btn>
				</v-card>
			</v-menu>
			<ao-btn
				v-else-if="continueBtn"
				color="primary"
				class="mr-6"
				:loading="loading"
				@click="onSubmit"
			>
				{{ $t('Continue') }}
			</ao-btn>
			<ao-btn
					v-else
					color="primary"
					class="mr-6"
					:disabled="disabled"
					:loading="loading"
					@click="onSubmit"
				>
				<slot name="submitButtonTitle">
					{{ $t('Save') }}
				</slot>
			</ao-btn>
		</template>
		<ao-btn
			v-if="!hideCancelBtn"
			variant="text"
			@click="onCancel"
		>
			{{ cancelBtnText ?? $t('Cancel') }}
		</ao-btn>
	</div>
</template>
<script>
export default {
	name: 'FormsFooter',
	props: {
		saveAndContinueBtn: {
			type: Boolean,
		},
		saveAddCloseAndNewBtn: {
			type: Boolean,
		},
		continueBtn: {
			type: Boolean,
		},
		hideSaveBtn: {
			type: Boolean,
			default: false,
		},
		cancelBtnText: {
			type: String,
		},
		hideCancelBtn: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		loading: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['onCancel', 'onSubmit'],
	data() {
		return {
			menu: false,
			menuSaveAddCloseAndNewBtn: false,
		}
	},
	methods: {
		onSubmit(val) {
			this.$emit('onSubmit', val)
		},
		onCancel() {
			this.$emit('onCancel')
		},
	},
}
</script>

<style lang="scss">
.ao-form-footer {
	background: #e6eef3;
	margin-top: auto;
}
</style>
